/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P2_Pro_TitleInputs */

const en_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet a Better You and a Better Earth with Plus`)
};

const ar_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قابل نسخة أفضل منك وأرضاً أفضل مع بلس`)
};

const de_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Plus zu einem besseren Leben und einer besseren Erde`)
};

const es_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubre una versión mejorada de ti y del mundo con Plus`)
};

const fr_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez une meilleure version de vous-même et une planète plus saine avec Plus`)
};

const it_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incontra una versione migliore di te stesso e una Terra migliore con Plus`)
};

const ja_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusでより素敵な自分と地球に出会いましょう`)
};

const ko_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus로 나 자신과 지구를 개선하세요`)
};

const pt_br_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conheça uma melhor versão de você e do planeta Terra com o Plus`)
};

const ru_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Улучшайте себя и Землю вместе с Plus`)
};

const th_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พบกับคุณและโลกที่ดียิ่งกว่าด้วย Plus`)
};

const tr_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus ile Daha İyi Bir Sen ve Daha İyi Bir Dünya ile Tanış`)
};

const zh_cn_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Plus，让自己和地球一起变得更美好`)
};

const zh_tw_subscription_walkthrough_p2_pro_title = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Plus，讓自己和地球一起變得更美好`)
};

/**
* | output |
* | --- |
* | "Meet a Better You and a Better Earth with Plus" |
*
* @param {Subscription_Walkthrough_P2_Pro_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p2_pro_title = /** @type {((inputs?: Subscription_Walkthrough_P2_Pro_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P2_Pro_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "de") return de_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "es") return es_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "it") return it_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "th") return th_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p2_pro_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p2_pro_title(inputs)
	return zh_tw_subscription_walkthrough_p2_pro_title(inputs)
});